import React from "react";
import { ConfigProvider, Button, Modal, Row } from "antd";
import { WarningFilled } from "@ant-design/icons";

// for translate
import { useTranslation } from "react-i18next";

// color config
import {
  textTitleHeader,
  colorButtonLogOut,
  colorTextTitleMobile,
} from "../config/constant/color/index";
import useBreakpoint from "antd/lib/grid/hooks/useBreakpoint";

const ModalConfirm = ({ isOpen, setIsOpen, handleModal, message }) => {
  const { t, i18n } = useTranslation();
  const screens = useBreakpoint();
  const isScallingVersion =
  window.innerWidth < 992 && (window.innerHeight >= window.innerWidth || window.innerWidth > window.innerHeight);
  const isMobileVersion = screens.xs || isScallingVersion;

  return (
    <ConfigProvider
      theme={{
        components: {
          Modal: {
            borderRadiusLG: "16px",
            borderRadiusSM: "16px",
            borderRadiusXS: "16px",
          },
        },
        token: {
          borderRadiusLG: 28,
          fontFamily: "Roboto",
          motionDurationMid: "0.2s",
        },
      }}
    >
      <Modal
        className="modal-confirm-general"
        open={isOpen}
        maskClosable="false"
        closeIcon={false}
        width={424}
        style={{ maxWidth: isMobileVersion ? "90%" : "424px" }}
        onCancel={() => setIsOpen(!isOpen)}
        transitionName="ant-fade"
        keyboard
        centered
        footer={
          <div
            style={{
              padding: isMobileVersion ? "0px 20px 20px 20px" : "0 32px 32px",
            }}
          >
            <Row
              style={{
                justifyContent: "space-between",
                flexWrap: isMobileVersion && "nowrap",
                gap: isMobileVersion && "4%",
              }}
            >
              <Button
                key="no-modal"
                className="btn btn-sm btn-secondary"
                style={{
                  width: isMobileVersion ? "48%" : "170px",
                  borderRadius: "6px",
                  border: "1px solid " + colorButtonLogOut,
                  fontSize: "14px",
                  fontWeight: "500",
                  height: isMobileVersion ? "40px" : "48px",
                }}
                name="btn-cancel-modal"
                onClick={() => setIsOpen(!isOpen)}
              >
                {t("feature.feature_cl.collection_action.no")}
              </Button>
              <Button
                key="yes-moda"
                className="btn btn-sm btn-secondary"
                style={{
                  width: isMobileVersion ? "48%" : "170px",
                  borderRadius: "6px",
                  border: "1px solid " + colorButtonLogOut,
                  fontSize: "14px",
                  fontWeight: "500",
                  height: isMobileVersion ? "40px" : "48px",
                }}
                name="btn-yes-modal"
                onClick={() => handleModal()}
              >
                {t("feature.feature_cl.collection_action.yes")}
              </Button>
            </Row>
          </div>
        }
      >
        <div
          style={{
            padding: isMobileVersion ? "20px 20px 0 20px" : "31px 32px 0",
            margin: "0",
          }}
        >
          <div style={{ textAlign: "center", marginBottom: "23px" }}>
            <p
              style={{
                color: isMobileVersion ? colorTextTitleMobile : textTitleHeader,
                fontWeight: "500",
                fontSize: isMobileVersion ? 16 : 22,
                margin: 0,
              }}
            >
              {message}
            </p>
          </div>
        </div>
      </Modal>
    </ConfigProvider>
  );
};

export default ModalConfirm;
